<template>
  <section class="mega-leadership bg-gradient-to-br from-green-400 to-green-500 py-20">
    <div class="container mx-auto px-4">
      <!-- Section Header -->
      <div class="text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-white">
          {{ $t("employee.team") }}
        </h2>
        <p class="text-white mt-4 max-w-2xl mx-auto text-lg">
          {{ $t("employee.responsibles") }}
        </p>
      </div>

      <!-- Leadership Grid -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        <!-- CEO -->
        <div class="mega-leader-card bg-white/95 backdrop-blur-sm rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-white/20">
          <div class="p-8 flex flex-col items-center">
            <h3 class="text-2xl font-semibold text-center text-gray-800">{{ $t("employee.firstCard.name") }}</h3>
            <p class="text-gray-600 mt-2 text-center font-medium">{{ $t("employee.firstCard.job") }}</p>
            <p class="text-gray-600 mt-4 text-center leading-relaxed">
              {{ $t("employee.firstCard.description") }}
            </p>
            
            <!-- Contact Links -->
          </div>
        </div>

        <!-- CTO -->
        <div class="mega-leader-card bg-white/95 backdrop-blur-sm rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-white/20">
          <div class="p-8 flex flex-col items-center">
            <h3 class="text-2xl font-semibold text-center text-gray-800">{{ $t("employee.secondCard.name") }}</h3>
            <p class="text-gray-600 mt-2 text-center font-medium">{{ $t("employee.secondCard.job") }}</p>
            <p class="text-gray-600 mt-4 text-center leading-relaxed">
              {{ $t("employee.secondCard.description") }}
            </p>
          </div>
        </div>

        <!-- CFO -->
        <div class="mega-leader-card bg-white/95 backdrop-blur-sm rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 border border-white/20">
          <div class="p-8 flex flex-col items-center">
            <h3 class="text-2xl font-semibold text-center text-gray-800">{{ $t("employee.thirdCard.name") }}</h3>
            <p class="text-gray-600 mt-2 text-center font-medium">{{ $t("employee.thirdCard.job") }}</p>
            <p class="text-gray-600 mt-4 text-center leading-relaxed">
              {{ $t("employee.thirdCard.description") }}
            </p>
            
           
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.mega-leader-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.mega-leader-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

@media (max-width: 768px) {
  .grid-cols-3 {
    grid-template-columns: 1fr;
    max-width: 400px;
    margin: 0 auto;
  }
  
  .mega-leader-card {
    padding: 1.5rem;
  }
}
</style>